import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext } from "react";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";
import { Carousel } from "../Carousel";
import styles from "./PushBlockContainer.module.scss";
export const PushBlockContainerContext = createContext({
    isCarousel: false,
});
export const PushBlockContainer = ({ children, tabletItemCount = 2, desktopItemCount = 3, carouselDesktop = false, }) => {
    const { mainBreakpoint } = useCurrentBreakpoint();
    const isDesktop = ["lg", "md"].includes(mainBreakpoint);
    const isCarousel = carouselDesktop || !isDesktop;
    return (_jsx("div", { className: styles.content, children: _jsx(PushBlockContainerContext.Provider, { value: { isCarousel }, children: isCarousel ? (_jsx(Carousel, { tabletItemCount: tabletItemCount, desktopItemCount: desktopItemCount, children: children })) : (_jsx(_Fragment, { children: children })) }) }));
};
//# sourceMappingURL=PushBlockContainer.js.map